import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFieldActivity from '../_reducers/fieldActivity';

export const selectFieldActivityState =
  createFeatureSelector<fromFieldActivity.FieldActivityState>('fieldActivities');

export const selectAllFieldActivities = createSelector(
  selectFieldActivityState,
  fromFieldActivity.selectAll
);

export const selectFieldActivityWithStatus = createSelector(
  selectFieldActivityState,
  selectAllFieldActivities,
  (state, fields) => ({
    fields,
    loading: state.loading,
    loaded: state.loaded,
    error: state.error,
  })
);
